// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/TrackingMgtPage/TrackingMgtPage.css */

/* --- Base Page & Empty State --- */
.tracking-mgt-page {
  animation: fadeIn 0.5s ease-in-out;
}
.page--empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 70vh;
  text-align: center;
}
.page--empty img {
  width: 100px;
  height: 100px;
  margin-bottom: 24px;
  opacity: 0.8;
}
.page--empty h3 {
  font-size: 20px;
  font-weight: 500;
  color: #6b7280;
}

/* --- Header & Controls --- */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.page-header h3 {
  font-size: 20px;
  font-weight: 600;
  color: #174078;
  margin: 0;
}
.page-controls {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.create-tracking-btn {
  background-color: #174078;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
}
.create-tracking-btn:hover {
  background-color: #12325f;
}
.page-error {
  color: #dc2626;
  margin-bottom: 16px;
  font-size: 14px;
}
.filter-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 8px;
  cursor: pointer;
}
.filter-btn img {
  height: 20px;
}
.page-search-bar {
  display: flex;
  align-items: center;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 0 12px;
  width: 300px;
}
.page-search-bar img {
  height: 16px;
  opacity: 0.5;
}
.page-search-bar input {
  border: none;
  outline: none;
  padding: 10px 8px;
  font-size: 14px;
  flex-grow: 1;
  background: transparent;
}

/* --- Table Styling --- */
.table-container {
  background-color: #fff;
  border-radius: 12px;
  overflow-x: auto;
}
.data-table {
  width: 100%;
  border-collapse: collapse;
}
.data-table th,
.data-table td {
  padding: 16px 24px;
  text-align: left;
  border-bottom: 1px solid #f3f4f6;
  font-size: 14px;
  white-space: nowrap;
}
.data-table th {
  background-color: #f2f7ff;
  color: #1e3a8a;
  font-weight: 600;
  text-transform: none;
}
.data-table td {
  color: #374151;
}
.data-table tbody tr:last-child td {
  border-bottom: none;
}

/* --- Status Dropdown Cell --- */
.status-cell {
  overflow: visible;
}
.status-dropdown-container {
  position: relative;
  display: inline-block;
  width: 100%;
}
.status-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
  border: none !important;
  transition: border-color 0.2s;

  background-color: none !important;
}
.status-wrapper:hover {
  border-color: #9ca3af;
}
.status-wrapper span {
  font-weight: 500;
  color: black !important;
  background-color: white !important;
}
.status-wrapper img {
  width: 16px;
  transition: transform 0.2s ease;
}
.status-wrapper img.open {
  transform: rotate(180deg);
}

.status-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background-color: #fff;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 10;
  max-height: 220px;
  overflow-y: auto;
}
.dropdown-item {
  padding: 12px 16px;
  cursor: pointer;
  font-size: 14px;
}
.dropdown-item:hover {
  background-color: #f3f4f6;
}

/* --- Footer & Pagination --- */

/* --- RESPONSIVE STYLES --- */
@media (max-width: 992px) {
  .page-header {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
  }
  .page-controls {
    justify-content: space-between;
  }
}
@media (max-width: 768px) {
  .data-table thead {
    display: none;
  }
  .data-table tr {
    display: block;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    margin-bottom: 1rem;
    padding: 1rem;
  }
  .data-table td {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #f3f4f6;
    white-space: normal;
  }
  .data-table td:last-child {
    border-bottom: none;
  }
  .data-table td::before {
    content: attr(data-label);
    font-weight: 600;
    color: #4b5563;
  }
  /* Make the status dropdown full width on mobile */
  .data-table td.status-cell .status-dropdown-container {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/TrackingMgtPage/TrackingMgtPage.css"],"names":[],"mappings":"AAAA,kDAAkD;;AAElD,oCAAoC;AACpC;EACE,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;;AAEA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;;EAE7B,iCAAiC;AACnC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,+BAA+B;AACjC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;;AAEA,gCAAgC;;AAEhC,8BAA8B;AAC9B;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;EACA;IACE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;EAChB;EACA,kDAAkD;EAClD;IACE,WAAW;EACb;AACF","sourcesContent":["/* src/pages/TrackingMgtPage/TrackingMgtPage.css */\n\n/* --- Base Page & Empty State --- */\n.tracking-mgt-page {\n  animation: fadeIn 0.5s ease-in-out;\n}\n.page--empty {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 70vh;\n  text-align: center;\n}\n.page--empty img {\n  width: 100px;\n  height: 100px;\n  margin-bottom: 24px;\n  opacity: 0.8;\n}\n.page--empty h3 {\n  font-size: 20px;\n  font-weight: 500;\n  color: #6b7280;\n}\n\n/* --- Header & Controls --- */\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n.page-header h3 {\n  font-size: 20px;\n  font-weight: 600;\n  color: #174078;\n  margin: 0;\n}\n.page-controls {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n.create-tracking-btn {\n  background-color: #174078;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 8px 14px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.create-tracking-btn:hover {\n  background-color: #12325f;\n}\n.page-error {\n  color: #dc2626;\n  margin-bottom: 16px;\n  font-size: 14px;\n}\n.filter-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  padding: 8px;\n  cursor: pointer;\n}\n.filter-btn img {\n  height: 20px;\n}\n.page-search-bar {\n  display: flex;\n  align-items: center;\n  background-color: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  padding: 0 12px;\n  width: 300px;\n}\n.page-search-bar img {\n  height: 16px;\n  opacity: 0.5;\n}\n.page-search-bar input {\n  border: none;\n  outline: none;\n  padding: 10px 8px;\n  font-size: 14px;\n  flex-grow: 1;\n  background: transparent;\n}\n\n/* --- Table Styling --- */\n.table-container {\n  background-color: #fff;\n  border-radius: 12px;\n  overflow-x: auto;\n}\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n.data-table th,\n.data-table td {\n  padding: 16px 24px;\n  text-align: left;\n  border-bottom: 1px solid #f3f4f6;\n  font-size: 14px;\n  white-space: nowrap;\n}\n.data-table th {\n  background-color: #f2f7ff;\n  color: #1e3a8a;\n  font-weight: 600;\n  text-transform: none;\n}\n.data-table td {\n  color: #374151;\n}\n.data-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* --- Status Dropdown Cell --- */\n.status-cell {\n  overflow: visible;\n}\n.status-dropdown-container {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n.status-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  padding: 8px 12px;\n  border-radius: 6px;\n  border: none !important;\n  transition: border-color 0.2s;\n\n  background-color: none !important;\n}\n.status-wrapper:hover {\n  border-color: #9ca3af;\n}\n.status-wrapper span {\n  font-weight: 500;\n  color: black !important;\n  background-color: white !important;\n}\n.status-wrapper img {\n  width: 16px;\n  transition: transform 0.2s ease;\n}\n.status-wrapper img.open {\n  transform: rotate(180deg);\n}\n\n.status-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  background-color: #fff;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  z-index: 10;\n  max-height: 220px;\n  overflow-y: auto;\n}\n.dropdown-item {\n  padding: 12px 16px;\n  cursor: pointer;\n  font-size: 14px;\n}\n.dropdown-item:hover {\n  background-color: #f3f4f6;\n}\n\n/* --- Footer & Pagination --- */\n\n/* --- RESPONSIVE STYLES --- */\n@media (max-width: 992px) {\n  .page-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 1rem;\n  }\n  .page-controls {\n    justify-content: space-between;\n  }\n}\n@media (max-width: 768px) {\n  .data-table thead {\n    display: none;\n  }\n  .data-table tr {\n    display: block;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    margin-bottom: 1rem;\n    padding: 1rem;\n  }\n  .data-table td {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 0;\n    border-bottom: 1px solid #f3f4f6;\n    white-space: normal;\n  }\n  .data-table td:last-child {\n    border-bottom: none;\n  }\n  .data-table td::before {\n    content: attr(data-label);\n    font-weight: 600;\n    color: #4b5563;\n  }\n  /* Make the status dropdown full width on mobile */\n  .data-table td.status-cell .status-dropdown-container {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
